import { html, svg } from "lit";
import { svgAttr } from "./attr.js";
import { isString } from "sharekit/is.js";
const h = html;
export const icon = (viewBox) => (strings, ...values) => {
    const body = svg(strings, values);
    const s = isString(viewBox) ? viewBox : viewBox.join(" ");
    const renderer = (attributes) => h `<svg viewBox="${s}"${svgAttr(attributes)}>${body}</svg>`;
    renderer.body = body;
    renderer.viewBox = s;
    return renderer;
};
//# sourceMappingURL=icon.js.map